'use client'

import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

import { cn } from '@/lib/utils'

const Popover = PopoverPrimitive.Root

const PopoverArrow = PopoverPrimitive.Arrow
const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    container?: Element | DocumentFragment
  }
>(
  (
    { className, align = 'center', sideOffset = 4, container, ...props },
    ref
  ) => (
    <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          // z-[110] on mobile: above the sticky app Header (~z-[100], see
          // app/components/Header), matching Dialog's content tier — on
          // mobile viewports a Popover can open close enough to the top
          // of the page that the header would otherwise paint over it
          '~z-50 max-sm:~z-[110] ~w-[320px] ~rounded-2xs ~border ~border-muted ~bg-popover ~p-4 ~text-popover-foreground ~shadow-md ~outline-none data-[state=open]:~animate-in data-[state=closed]:~animate-out data-[state=closed]:~fade-out-0 data-[state=open]:~fade-in-0 data-[state=closed]:~zoom-out-95 data-[state=open]:~zoom-in-95 data-[side=bottom]:~slide-in-from-top-2 data-[side=left]:~slide-in-from-right-2 data-[side=right]:~slide-in-from-left-2 data-[side=top]:~slide-in-from-bottom-2',
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverContent, PopoverTrigger, PopoverArrow }
